import { render, staticRenderFns } from "./RestoreView.vue?vue&type=template&id=0d3d054b&"
import script from "./RestoreView.vue?vue&type=script&lang=js&"
export * from "./RestoreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports